import PropTypes from 'prop-types';
import React from 'react';

import { iconStyle } from './iconStyle';

export default class Icon extends React.PureComponent {
    render() {
        return (
            <div className={`component-Elements-Icon ${this.props.size}`}>
                <style jsx>
                    {`
                        ${iconStyle}
                    `}
                </style>
                <div
                    className={`icon ${this.props.name} ${this.props.bgColor}`}
                />
            </div>
        );
    }
}
Icon.propTypes = {
    /**
     * Name of the icon: eg: "facebook", "instagram", ect
     */
    name: PropTypes.string.isRequired,
    /**
     * Background color of the icon: current supporting "primary-bg" and "black-bg"
     */
    bgColor: PropTypes.string,
    size: PropTypes.string,
};

Icon.defaultProps = {
    bgColor: 'primary-bg',
    size: '',
};
